"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoadingScreenModal;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _LoadingScreenModalModule = _interopRequireDefault(require("./LoadingScreenModal.module.scss"));

var _Modal = _interopRequireDefault(require("../../common/Modal/Modal"));

var _progressBars = require("../../progressBars");

var _BorderedBox = _interopRequireDefault(require("../../common/BorderedBox/BorderedBox"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LoadingScreenModal(_ref) {
  var closeFunc = _ref.closeFunc,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 0 : _ref$type,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    closeFunc: closeFunc,
    className: (0, _classnames.default)(className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_BorderedBox.default, {
    type: "MAIN_2",
    contentClassName: (0, _classnames.default)(_LoadingScreenModalModule.default.window, _LoadingScreenModalModule.default["type".concat(type)])
  }, /*#__PURE__*/_react.default.createElement(_progressBars.ProgressBarAnimated, {
    interval: 10,
    className: _LoadingScreenModalModule.default.progressBar
  })));
}